import React from 'react';
import './Terms.css';

const PrivacyPolicySE = () => {
  return (
    <div className="terms-page">
      <h1>Integritetspolicy</h1>
      <div className="terms-main">
        <p>
          Rewards &amp; Samples, LLC ("vi", "oss" eller "vår") respekterar din integritet och är
          engagerade i att skydda dina personuppgifter. Denna integritetspolicy beskriver hur vi
          samlar in, använder och delar information om dig.
        </p>

        <h3>1. INFORMATION VI SAMLAR IN</h3>
        <p>Vi samlar in information som du ger oss direkt, t.ex.:</p>
        <ul>
          <li>E-postadress</li>
          <li>Namn och kontaktuppgifter</li>
          <li>Annan information du väljer att lämna</li>
        </ul>

        <h3>2. HUR VI ANVÄNDER DIN INFORMATION</h3>
        <p>Vi använder informationen vi samlar in för att:</p>
        <ul>
          <li>Tillhandahålla, underhålla och förbättra våra tjänster</li>
          <li>Behandla transaktioner och skicka relaterade uppgifter</li>
          <li>Skicka tekniska meddelanden och supportmeddelanden</li>
          <li>Svara på kommentarer och frågor</li>
          <li>Skicka marknadsföringskommunikation</li>
        </ul>

        <h3>3. COOKIES</h3>
        <p>
          Vi använder cookies och liknande spårningstekniker för att spåra aktivitet på vår
          webbplats och lagra viss information. Du kan instruera din webbläsare att vägra alla
          cookies eller att indikera när en cookie skickas.
        </p>

        <h3>4. DATADELNING</h3>
        <p>
          Vi delar inte dina personuppgifter med tredje parter utan ditt samtycke, förutom vad
          som krävs enligt lag eller för att tillhandahålla de tjänster du begärt.
        </p>

        <h3>5. DATASÄKERHET</h3>
        <p>
          Vi implementerar lämpliga tekniska och organisatoriska åtgärder för att skydda dina
          personuppgifter mot obehörig åtkomst, förlust eller förstörelse.
        </p>

        <h3>6. DINA RÄTTIGHETER (GDPR)</h3>
        <p>Enligt GDPR har du rätt att:</p>
        <ul>
          <li>Få tillgång till dina personuppgifter</li>
          <li>Begära rättelse av felaktiga uppgifter</li>
          <li>Begära radering av dina uppgifter</li>
          <li>Invända mot behandling av dina uppgifter</li>
          <li>Begära begränsning av behandlingen</li>
          <li>Dataportabilitet</li>
        </ul>

        <h3>7. KONTAKTA OSS</h3>
        <p>
          Om du har frågor om denna integritetspolicy eller vill utöva dina rättigheter, vänligen
          kontakta oss.
        </p>

        <div className="last-updated">Senast uppdaterad: Januari 2026</div>
      </div>
    </div>
  );
};

export default PrivacyPolicySE;
